
export const translations = {
  en: {
    dashboard: "Overview",
    stock_list: "VMI",
    replenishment: "Consignment Stock",
    warning_levels: "Warning Levels",
    vmi_interface: "VMI Interface",
    product_tour: "System Tour",
    search_resources: "Search inventory...",
    back: "Back",
    general_settings: "General Settings",
    users_settings: "User Management",
    profile_settings: "Profile",
    sign_out: "Sign out",
    item_number: "Item Number",
    item_name: "Item Name",
    supplier: "Supplier",
    current_stock: "Current Stock",
    min_stock: "Min. Stock",
    status: "Status",
    actions: "Actions",
    export_list: "Export List",
    advanced_filter: "Filter",
    showing_x_of_y: "Showing {x} of {y} items",
    healthy: "Healthy",
    critical: "Critical",
    warning: "Warning",
    all: "All",
    filter_supplier: "Filter Supplier",
    filter_status: "Filter Status",
    plan_replenishment: "Plan Consignment",
    view_details: "View Details",
    stock_overview: "Stock Overview",
    total_products: "Total Products",
    critical_items: "Critical Items",
    healthy_items: "Healthy Items",
    inventory_health: "Inventory Health",
    replenish_stock: "Consign Stock",
    sign_in: "Sign In",
    sign_in_supplier: "Supplier Portal Login",
    supplier_portal: "Supplier Portal",
    my_products: "My Products",
    critical_stock_levels: "Critical Stock Levels",
    warnings: "Warnings",
    stock_at_customer_location: "Stock at Customer Location",
    last_updated: "Last Updated",
    overview: "Overview",
    orders: "Orders",
    lead_time: "Lead Time",
    unit_price: "Unit Price",
    open_orders: "Open Orders",
    order_date: "Order Date",
    delivery_date: "Delivery Date",
    order_qty: "Order Qty",
    fulfillment_status: "Fulfillment Status",
    add_to_cart: "Add to Cart",
    cart: "Cart",
    empty_cart: "Your cart is empty",
    place_order: "Place Order",
    items: "Items",
    total: "Total",
    grid_view: "Grid View",
    list_view: "List View",
    quantity: "Qty",
    channel_settings: "Channel Settings",
    plan_billing: "Plan & Billing",
    ready_to_route: "Ready to Route",
    company: "Company",
    update: "Update",
    invoice_management: "Invoice Management",
    debtors: "Debtors",
    invoice: "Invoice",
    search_invoices: "Search Invoices",
    send: "Send",
    doc_number: "Document Number",
    customer_name: "Customer Name",
    due_date: "Due Date",
    amount: "Amount",
    channel: "Channel",
    sent: "Sent",
    failed: "Failed",
    draft: "Draft",
    search_orders: "Search Orders",
    creditors: "Creditors",
    settings: "Settings",
    change_avatar: "Change Avatar",
    delete_photo: "Delete Photo",
    personal_information: "Personal Information",
    first_name: "First Name",
    last_name: "Last Name",
    email_address: "Email Address",
    interface_preferences: "Interface Preferences",
    language: "Language",
    timezone: "Timezone",
    discard_changes: "Discard Changes",
    save_changes: "Save Changes",
    channel_configuration: "Channel Configuration",
    live: "Live",
    inactive: "Inactive",
    endpoint: "Endpoint",
    active: "Active",
    paused: "Paused",
    change_priority: "Change Priority",
    expand_reach: "Expand Reach",
    contact_engineer: "Contact Engineer",
    current_plan: "Current Plan",
    upgrade_plan: "Upgrade Plan",
    usage_tracker: "Usage Tracker",
    next_reset: "Next Reset",
    payment_method: "Payment Method",
    billing_history: "Billing History",
    invoice_id: "Invoice ID",
    date: "Date",
    delivery_method: "Delivery Method",
    exchange_server: "Exchange Server",
    smtp_server: "SMTP Server",
    host: "Host",
    port: "Port",
    login_email: "Login Email",
    tenant_id: "Tenant ID",
    client_id: "Client ID",
    client_secret: "Client Secret",
    verify_connection: "Verify Connection",
    verification_pending: "Verification Pending",
    email_delivery_config: "Email Delivery Config",
    emails_per_day: "Emails Per Day",
    sender_email: "Sender Email",
    same_as_login: "Same as Login",
    attachment_standard: "Attachment Standard",
    standard_pdf: "Standard PDF",
    hybrid_pdf_xml: "Hybrid PDF/XML",
    establish_gateway: "Establish Gateway",
    gateway_established: "Gateway Established",
    email_gateway_verified: "Email Gateway Verified",
    continue_dashboard: "Continue to Dashboard",
    channel_priority: "Channel Priority",
    processing_order: "Processing Order",
    cancel: "Cancel",
    customers: "Customers",
    customer: "Customer",
    my_customers: "My Customers",
    managed_skus: "Managed SKUs",
    critical_alerts: "Critical Alerts",
    healthy_status: "Healthy Status",
    propose_consignment: "Propose Consignment",
    no_stock_data: "No stock data available or matching filters",
    cart_title: "Cart",
    clear_all: "Clear All",
    subtotal: "Subtotal ({count} items)",
    estimated_tax: "Estimated Tax",
    grand_total: "Grand Total",
    order_summary: "Order Summary",
    cart_legal_disclaimer: "By placing this order, you authorize the generation of a purchase document for your organization.",
    fulfillment_badge_title: "VMI Fulfillment",
    fulfillment_badge_desc: "Orders are automatically verified against customer stock levels and processed via EDI gateway.",
    go_to_products: "GO TO PRODUCTS",
    empty_cart_desc: "Browse your product catalog to add items for consignment.",
    incoming_requests: "Incoming Requests",
    order_requests: "Order Requests",
    batch_export: "Batch Export",
    request_number: "Request Number",
    items_count: "Items Count",
    requested_amount: "Requested Amount",
    convert_to_order: "CONVERT TO ORDER",
    new: "New",
    ordered: "Ordered",
    new_request: "New Request",
    order_confirmed: "Order Confirmed",
    rejected: "Rejected",
    po_number: "PO Number",
    shipped: "Shipped",
    delivered: "Delivered",
    open: "Open",
    inventory_by_category: "Inventory by Category",
    stock_health_overview: "Stock Health Overview",
    detailed_stock_mgmt: "Detailed Stock Management",
    detailed_stock_desc: "View complete inventory list, filter by suppliers, export data, and manage stock levels in the dedicated Stock List view.",
    go_to_stock_list: "Go to Stock List",
    current_distribution: "Current distribution of stock health across all items.",
    filter_placeholder: "Filter...",
    search_requests: "Search requests..."
  },
  de: {
    dashboard: "Übersicht",
    stock_list: "VMI",
    replenishment: "Konsignationslager",
    warning_levels: "Warnstufen",
    vmi_interface: "VMI-Schnittstelle",
    product_tour: "Systemtour",
    search_resources: "Inventar durchsuchen...",
    back: "Zurück",
    general_settings: "Allgemein",
    users_settings: "Benutzerverwaltung",
    profile_settings: "Profil",
    sign_out: "Abmelden",
    item_number: "Artikelnummer",
    item_name: "Artikelname",
    supplier: "Lieferant",
    current_stock: "Aktueller Bestand",
    min_stock: "Mindestbestand",
    status: "Status",
    actions: "Aktionen",
    export_list: "Liste exportieren",
    advanced_filter: "Filter",
    showing_x_of_y: "Zeige {x} von {y} Artikeln",
    healthy: "Gesund",
    critical: "Kritisch",
    warning: "Warnung",
    all: "Alle",
    filter_supplier: "Lieferant filtern",
    filter_status: "Status filtern",
    plan_replenishment: "Konsignation planen",
    view_details: "Details anzeigen",
    stock_overview: "Bestandsübersicht",
    total_products: "Gesamtprodukte",
    critical_items: "Kritische Artikel",
    healthy_items: "Gesunde Artikel",
    inventory_health: "Bestandsgesundheit",
    replenish_stock: "Bestand auffüllen",
    sign_in: "Anmelden",
    sign_in_supplier: "Lieferantenportal Login",
    supplier_portal: "Lieferantenportal",
    my_products: "Meine Produkte",
    critical_stock_levels: "Kritische Lagerbestände",
    warnings: "Warnungen",
    stock_at_customer_location: "Bestand beim Kunden",
    last_updated: "Zuletzt aktualisiert",
    overview: "Übersicht",
    orders: "Bestellungen",
    lead_time: "Lieferzeit",
    unit_price: "Einzelpreis",
    open_orders: "Offene Bestellungen",
    order_date: "Bestelldatum",
    delivery_date: "Lieferdatum",
    order_qty: "Bestellmenge",
    fulfillment_status: "Erfüllungsstatus",
    add_to_cart: "In den Warenkorb",
    cart: "Warenkorb",
    empty_cart: "Ihr Warenkorb ist leer",
    place_order: "Bestellung aufgeben",
    items: "Artikel",
    total: "Gesamt",
    grid_view: "Rasteransicht",
    list_view: "Listenansicht",
    quantity: "Menge",
    channel_settings: "Kanaleinstellungen",
    plan_billing: "Plan & Abrechnung",
    ready_to_route: "Bereit zum Routing",
    company: "Firma",
    update: "Aktualisieren",
    invoice_management: "Rechnungsverwaltung",
    debtors: "Debitoren",
    invoice: "Rechnung",
    search_invoices: "Rechnungen suchen",
    send: "Senden",
    doc_number: "Belegnummer",
    customer_name: "Kundenname",
    due_date: "Fälligkeitsdatum",
    amount: "Betrag",
    channel: "Kanal",
    sent: "Gesendet",
    failed: "Fehlgeschlagen",
    draft: "Entwurf",
    search_orders: "Bestellungen suchen",
    creditors: "Kreditoren",
    settings: "Einstellungen",
    change_avatar: "Avatar ändern",
    delete_photo: "Foto löschen",
    personal_information: "Persönliche Informationen",
    first_name: "Vorname",
    last_name: "Nachname",
    email_address: "E-Mail-Adresse",
    interface_preferences: "Schnittstelleneinstellungen",
    language: "Sprache",
    timezone: "Zeitzone",
    discard_changes: "Änderungen verwerfen",
    save_changes: "Änderungen speichern",
    channel_configuration: "Kanalkonfiguration",
    live: "Live",
    inactive: "Inaktiv",
    endpoint: "Endpunkt",
    active: "Aktiv",
    paused: "Pausiert",
    change_priority: "Priorität ändern",
    expand_reach: "Reichweite erweitern",
    contact_engineer: "Techniker kontaktieren",
    current_plan: "Aktueller Plan",
    upgrade_plan: "Plan upgraden",
    usage_tracker: "Nutzungsverfolgung",
    next_reset: "Nächster Reset",
    payment_method: "Zahlungsmethode",
    billing_history: "Rechnungshistorie",
    invoice_id: "Rechnungs-ID",
    date: "Datum",
    delivery_method: "Versandart",
    exchange_server: "Exchange Server",
    smtp_server: "SMTP Server",
    host: "Host",
    port: "Port",
    login_email: "Anmelde-E-Mail",
    tenant_id: "Tenant-ID",
    client_id: "Client-ID",
    client_secret: "Client-Secret",
    verify_connection: "Verbindung prüfen",
    verification_pending: "Prüfung ausstehend",
    email_delivery_config: "E-Mail-Versandkonfiguration",
    emails_per_day: "E-Mails pro Tag",
    sender_email: "Absender-E-Mail",
    same_as_login: "Identisch mit Login",
    attachment_standard: "Anhang-Standard",
    standard_pdf: "Standard PDF",
    hybrid_pdf_xml: "Hybrid-PDF mit eingebetteten XML-Daten",
    email_template: "E-Mail-Vorlage",
    subject: "Betreff",
    establish_gateway: "Gateway einrichten",
    gateway_established: "Gateway eingerichtet",
    email_gateway_verified: "Die E-Mail-Gateway-Verbindung wurde erfolgreich verifiziert und gespeichert.",
    continue_dashboard: "Weiter zum Dashboard",
    channel_priority: "Kanalpriorität",
    processing_order: "Verarbeitungsreihenfolge",
    cancel: "Abbrechen",
    customers: "Kunden",
    customer: "Kunde",
    my_customers: "Meine Kunden",
    managed_skus: "Verwaltete Artikel",
    critical_alerts: "Kritische Alarme",
    healthy_status: "Gesunder Status",
    propose_consignment: "Konsignation vorschlagen",
    no_stock_data: "Keine Bestandsdaten verfügbar oder Filterkriterien stimmen nicht überein",
    cart_title: "Warenkorb",
    clear_all: "Alles löschen",
    subtotal: "Zwischensumme ({count} Artikel)",
    estimated_tax: "Geschätzte Steuer",
    grand_total: "Gesamtsumme",
    order_summary: "Bestellübersicht",
    cart_legal_disclaimer: "Mit dieser Bestellung autorisieren Sie die Erstellung eines Kaufbelegs für Ihr Unternehmen.",
    fulfillment_badge_title: "VMI-Erfüllung",
    fulfillment_badge_desc: "Bestellungen werden automatisch gegen Kundenbestände geprüft und über das EDI-Gateway verarbeitet.",
    go_to_products: "ZU DEN PRODUKTEN",
    empty_cart_desc: "Durchsuchen Sie Ihren Produktkatalog, um Artikel für die Konsignation hinzuzufügen.",
    incoming_requests: "Eingehende Anfragen",
    order_requests: "Bestellanfragen",
    batch_export: "Stapelexport",
    request_number: "Anfragenummer",
    items_count: "Anzahl Artikel",
    requested_amount: "Angefragter Betrag",
    convert_to_order: "IN BESTELLUNG UMWANDELN",
    new: "Neu",
    ordered: "Bestellt",
    new_request: "Neue Anfrage",
    order_confirmed: "Bestellung bestätigt",
    rejected: "Abgelehnt",
    po_number: "Bestellnummer",
    shipped: "Versandt",
    delivered: "Geliefert",
    open: "Offen",
    inventory_by_category: "Inventar nach Kategorie",
    stock_health_overview: "Bestandsgesundheit Übersicht",
    detailed_stock_mgmt: "Detaillierte Bestandsverwaltung",
    detailed_stock_desc: "Zeigen Sie die vollständige Inventarliste an, filtern Sie nach Lieferanten, exportieren Sie Daten und verwalten Sie Bestände in der dedizierten Bestandsliste.",
    go_to_stock_list: "Zur Bestandsliste",
    current_distribution: "Aktuelle Verteilung der Bestandsgesundheit über alle Artikel.",
    filter_placeholder: "Filtern...",
    search_requests: "Anfragen suchen..."
  }
};
